module.exports = __webpack_public_path__ + "images/emoji/yen.5c40eb8b614fa53bd814.png";